import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { spacing } from 'ui/theme';

export const DelayTimeWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const DelayInputText = styled(InputText)`
  flex: 1;
`;
